var _module = require('../components/module');

/*
initials
*/
_module.filter('initials', [
    function () {
        return function initials(str) {
            return (str||'')
                        .split(' ')
                        .filter(function (s, i, arr) {
                            return (i === 0 || i === (arr.length - 1));
                        })
                        .map(function (s) {
                            return s.charAt(0);
                        })
                        .join('')
                        .toUpperCase()
                        .trim()
                        .substr(0,2);
        };
    }
]);
